module.exports = __webpack_public_path__ + "static/media/thumbs-down.bd7fe5d3.png";